import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { Folder, Brain, MessageCircle, CheckCircle2, ArrowRight } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-16 bg-white" data-id="element-229">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-230">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-231">
          <span className="inline-block bg-pink-100 text-pink-800 px-4 py-1.5 rounded-full font-bold text-xs tracking-widest uppercase mb-6" data-id="element-232">
            La solución
          </span>
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-navy-900 mb-4 uppercase tracking-tight" data-id="element-233">
            Inicio en la
            <br data-id="element-234" />
            <span className="text-pink-600" data-id="element-235">Psicopedagogía Clínica</span>
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-236">
            Un sistema completo para ayudarte a empezar clínica con más
            seguridad profesional.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-4 md:gap-3 mb-10 items-stretch" data-id="element-237">
          {[{
          icon: Folder,
          title: 'Organizás tu práctica',
          color: 'pink'
        }, {
          icon: Brain,
          title: 'Entendés qué hacer',
          color: 'rose'
        }, {
          icon: MessageCircle,
          title: 'Intervenís con claridad',
          color: 'fuchsia'
        }].map((step, i) => <Fragment key={i} data-id="element-238">
              <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-gradient-to-br from-slate-50 to-white rounded-2xl p-6 border border-slate-100 text-center flex-1" data-id="element-239">
                <div className={`w-14 h-14 rounded-2xl mx-auto mb-4 flex items-center justify-center ${step.color === 'pink' ? 'bg-pink-100 text-pink-700' : step.color === 'rose' ? 'bg-rose-100 text-rose-700' : 'bg-fuchsia-100 text-fuchsia-700'}`} data-id="element-240">
                  <step.icon className="w-7 h-7" data-id="element-241" />
                </div>
                <h3 className="font-bold text-navy-900 text-lg" data-id="element-242">
                  {step.title}
                </h3>
              </motion.div>
              {i < 2 && <div className="hidden md:flex items-center justify-center -mx-3" data-id="element-243">
                  <ArrowRight className="w-6 h-6 text-slate-300" data-id="element-244" />
                </div>}
            </Fragment>)}
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-2xl mx-auto" data-id="element-245">
          {['Sin improvisar', 'Sin sentirte perdida', 'Sin empezar de cero cada vez'].map((t, i) => <span key={i} className="inline-flex items-center gap-2 bg-pink-50 text-pink-700 font-semibold text-sm px-4 py-2 rounded-full border border-pink-100" data-id="element-246">
              <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-247" /> {t}
            </span>)}
        </div>
      </div>
    </section>;
}